import { cn } from "@/lib/utils";

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

export function FormField({ label, children, className }: FormFieldProps) {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <p className="text-sm font-medium text-(--color-text-secondary)">{label}</p>
      {children}
    </div>
  );
}
